<template lang="pug">
  abstract-manipulated-order-fields(
    action_name="edit" :manipulated_order_id= "manipulated_order_id" :manipulated_order_sid="manipulated_order_sid" button_label="更新"
  )
</template>

<script>
import AbstractManipulatedOrderFields  from 'components/manipulated_orders/abstract_manipulated_order_fields.vue'

export default {
  name: 'edit-manipulated-order-fields',
  components: { AbstractManipulatedOrderFields },
  data() {
    return {
    }
  },
  props: {
    manipulated_order_id: {
      type: String,
      required: true
    },
    manipulated_order_sid: {
      type: String,
      required: true
    }
  }
}
</script>